export default __webpack_public_path__ + "static/media/PasswordGen.f11a59ee.png";